export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371000; // Earth's radius in meters
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function parseGPX(gpxText) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(gpxText, 'text/xml');
  const trackpoints = [];
  let cumulativeDistance = 0;
  const trkptElements = xmlDoc.querySelectorAll('trkpt');

  for (let i = 0; i < trkptElements.length; i++) {
    const trkpt = trkptElements[i];
    const lat = parseFloat(trkpt.getAttribute('lat'));
    const lon = parseFloat(trkpt.getAttribute('lon'));
    const eleElement = trkpt.querySelector('ele');
    const ele = eleElement ? parseFloat(eleElement.textContent) : 0;

    const timeElement = trkpt.querySelector('time');
    const timestamp = timeElement ? new Date(timeElement.textContent) : null;

    if (i > 0) {
      const prevTrkpt = trackpoints[i - 1];
      cumulativeDistance += calculateDistance(prevTrkpt.lat, prevTrkpt.lon, lat, lon);
    }

    trackpoints.push({
      lat,
      lon,
      ele,
      cumulativeDistance,
      timestamp,
      heartRate: null,
      cadence: null,
      power: null,
      speed: null
    });
  }
  return trackpoints;
}
